//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import userRow from './UserList/UserRow';
import { Multiselect, Actions, ActionButton } from '@nextcloud/vue';
import InfiniteLoading from 'vue-infinite-loading';
import Vue from 'vue';
var unlimitedQuota = {
  id: 'none',
  label: t('settings', 'Unlimited')
};
var defaultQuota = {
  id: 'default',
  label: t('settings', 'Default quota')
};
var newUser = {
  id: '',
  displayName: '',
  password: '',
  mailAddress: '',
  groups: [],
  subAdminsGroups: [],
  quota: defaultQuota,
  language: {
    code: 'en',
    name: t('settings', 'Default language')
  }
};
export default {
  name: 'UserList',
  components: {
    userRow: userRow,
    Multiselect: Multiselect,
    InfiniteLoading: InfiniteLoading,
    Actions: Actions,
    ActionButton: ActionButton
  },
  props: {
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showConfig: {
      type: Object,
      required: true
    },
    selectedGroup: {
      type: String,
      default: null
    },
    externalActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      unlimitedQuota: unlimitedQuota,
      defaultQuota: defaultQuota,
      loading: {
        all: false,
        groups: false
      },
      scrolled: false,
      searchQuery: '',
      newUser: Object.assign({}, newUser)
    };
  },
  computed: {
    settings: function settings() {
      return this.$store.getters.getServerData;
    },
    selectedGroupDecoded: function selectedGroupDecoded() {
      return decodeURIComponent(this.selectedGroup);
    },
    filteredUsers: function filteredUsers() {
      if (this.selectedGroup === 'disabled') {
        return this.users.filter(function (user) {
          return user.enabled === false;
        });
      }

      if (!this.settings.isAdmin) {
        // we don't want subadmins to edit themselves
        return this.users.filter(function (user) {
          return user.enabled !== false;
        });
      }

      return this.users.filter(function (user) {
        return user.enabled !== false;
      });
    },
    groups: function groups() {
      // data provided php side + remove the disabled group
      return this.$store.getters.getGroups.filter(function (group) {
        return group.id !== 'disabled';
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    canAddGroups: function canAddGroups() {
      // disabled if no permission to add new users to group
      return this.groups.map(function (group) {
        // clone object because we don't want
        // to edit the original groups
        group = Object.assign({}, group);
        group.$isDisabled = group.canAdd === false;
        return group;
      });
    },
    subAdminsGroups: function subAdminsGroups() {
      // data provided php side
      return this.$store.getters.getSubadminGroups;
    },
    quotaOptions: function quotaOptions() {
      // convert the preset array into objects
      var quotaPreset = this.settings.quotaPreset.reduce(function (acc, cur) {
        return acc.concat({
          id: cur,
          label: cur
        });
      }, []); // add default presets

      quotaPreset.unshift(this.unlimitedQuota);
      quotaPreset.unshift(this.defaultQuota);
      return quotaPreset;
    },
    minPasswordLength: function minPasswordLength() {
      return this.$store.getters.getPasswordPolicyMinLength;
    },
    usersOffset: function usersOffset() {
      return this.$store.getters.getUsersOffset;
    },
    usersLimit: function usersLimit() {
      return this.$store.getters.getUsersLimit;
    },
    usersCount: function usersCount() {
      return this.users.length;
    },

    /* LANGUAGES */
    languages: function languages() {
      return [{
        label: t('settings', 'Common languages'),
        languages: this.settings.languages.commonlanguages
      }, {
        label: t('settings', 'All languages'),
        languages: this.settings.languages.languages
      }];
    }
  },
  watch: {
    // watch url change and group select
    selectedGroup: function selectedGroup(val, old) {
      // if selected is the disabled group but it's empty
      this.redirectIfDisabled();
      this.$store.commit('resetUsers');
      this.$refs.infiniteLoading.stateChanger.reset();
      this.setNewUserDefaultGroup(val);
    },
    // make sure the infiniteLoading state is changed if we manually
    // add/remove data from the store
    usersCount: function usersCount(val, old) {
      // deleting the last user, reset the list
      if (val === 0 && old === 1) {
        this.$refs.infiniteLoading.stateChanger.reset(); // adding the first user, warn the infiniteLoader that
        // the list is not empty anymore (we don't fetch the newly
        // added user as we already have all the info we need)
      } else if (val === 1 && old === 0) {
        this.$refs.infiniteLoading.stateChanger.loaded();
      }
    }
  },
  mounted: function mounted() {
    if (!this.settings.canChangePassword) {
      OC.Notification.showTemporary(t('settings', 'Password change is disabled because the master key is disabled'));
    }
    /**
     * Reset and init new user form
     */


    this.resetForm();
    /**
     * Register search
     */

    this.userSearch = new OCA.Search(this.search, this.resetSearch);
    /**
     * If disabled group but empty, redirect
     */

    this.redirectIfDisabled();
  },
  methods: {
    onScroll: function onScroll(event) {
      this.scrolled = event.target.scrollTo > 0;
    },

    /**
     * Validate quota string to make sure it's a valid human file size
     *
     * @param {string} quota Quota in readable format '5 GB'
     * @returns {Object}
     */
    validateQuota: function validateQuota(quota) {
      // only used for new presets sent through @Tag
      var validQuota = OC.Util.computerFileSize(quota);

      if (validQuota !== null && validQuota >= 0) {
        // unify format output
        quota = OC.Util.humanFileSize(OC.Util.computerFileSize(quota));
        this.newUser.quota = {
          id: quota,
          label: quota
        };
        return this.newUser.quota;
      } // Default is unlimited


      this.newUser.quota = this.quotaOptions[0];
      return this.quotaOptions[0];
    },
    infiniteHandler: function infiniteHandler($state) {
      this.$store.dispatch('getUsers', {
        offset: this.usersOffset,
        limit: this.usersLimit,
        group: this.selectedGroup !== 'disabled' ? this.selectedGroup : '',
        search: this.searchQuery
      }).then(function (response) {
        response ? $state.loaded() : $state.complete();
      });
    },

    /* SEARCH */
    search: function search(query) {
      this.searchQuery = query;
      this.$store.commit('resetUsers');
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    resetSearch: function resetSearch() {
      this.search('');
    },
    resetForm: function resetForm() {
      // revert form to original state
      this.newUser = Object.assign({}, newUser);
      /**
       * Init default language from server data. The use of this.settings
       * requires a computed variable, which break the v-model binding of the form,
       * this is a much easier solution than getter and setter on a computed var
       */

      if (this.settings.defaultLanguage) {
        Vue.set(this.newUser.language, 'code', this.settings.defaultLanguage);
      }
      /**
       * In case the user directly loaded the user list within a group
       * the watch won't be triggered. We need to initialize it.
       */


      this.setNewUserDefaultGroup(this.selectedGroup);
      this.loading.all = false;
    },
    createUser: function createUser() {
      var _this = this;

      this.loading.all = true;
      this.$store.dispatch('addUser', {
        userid: this.newUser.id,
        password: this.newUser.password,
        displayName: this.newUser.displayName,
        email: this.newUser.mailAddress,
        groups: this.newUser.groups.map(function (group) {
          return group.id;
        }),
        subadmin: this.newUser.subAdminsGroups.map(function (group) {
          return group.id;
        }),
        quota: this.newUser.quota.id,
        language: this.newUser.language.code
      }).then(function () {
        _this.resetForm();

        _this.$refs.newusername.focus();
      }).catch(function (error) {
        _this.loading.all = false;

        if (error.response && error.response.data && error.response.data.ocs && error.response.data.ocs.meta) {
          var statuscode = error.response.data.ocs.meta.statuscode;

          if (statuscode === 102) {
            // wrong username
            _this.$refs.newusername.focus();
          } else if (statuscode === 107) {
            // wrong password
            _this.$refs.newuserpassword.focus();
          }
        }
      });
    },
    setNewUserDefaultGroup: function setNewUserDefaultGroup(value) {
      if (value && value.length > 0) {
        // setting new user default group to the current selected one
        var currentGroup = this.groups.find(function (group) {
          return group.id === value;
        });

        if (currentGroup) {
          this.newUser.groups = [currentGroup];
          return;
        }
      } // fallback, empty selected group


      this.newUser.groups = [];
    },

    /**
     * Create a new group
     *
     * @param {string} gid Group id
     * @returns {Promise}
     */
    createGroup: function createGroup(gid) {
      var _this2 = this;

      this.loading.groups = true;
      this.$store.dispatch('addGroup', gid).then(function (group) {
        _this2.newUser.groups.push(_this2.groups.find(function (group) {
          return group.id === gid;
        }));

        _this2.loading.groups = false;
      }).catch(function () {
        _this2.loading.groups = false;
      });
      return this.$store.getters.getGroups[this.groups.length];
    },

    /**
     * If the selected group is the disabled group but the count is 0
     * redirect to the all users page.
     * * we only check for 0 because we don't have the count on ldap
     * * and we therefore set the usercount to -1 in this specific case
     */
    redirectIfDisabled: function redirectIfDisabled() {
      var allGroups = this.$store.getters.getGroups;

      if (this.selectedGroup === 'disabled' && allGroups.findIndex(function (group) {
        return group.id === 'disabled' && group.usercount === 0;
      }) > -1) {
        // disabled group is empty, redirection to all users
        this.$router.push({
          name: 'users'
        });
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
    onClose: function onClose() {
      this.showConfig.showNewUserForm = false;
    }
  }
};